@if (isOpen) {
  <!-- Backdrop overlay -->
  <div
    class="fixed inset-0 bg-black/30 z-40 transition-opacity duration-300 pointer-events-none"
    role="button"
    tabindex="0"
    (click)="onBackdropClick()"
    (keydown.escape)="onBackdropClick()"
    (keydown.enter)="onBackdropClick()"
  ></div>

  <!-- Sidebar panel -->
  <aside
    class="fixed top-sidebar-top right-12 w-sidebar-panel max-h-sidebar-calc bg-white shadow-sidebar z-sidebar-sm flex flex-col gap-8 p-6 rounded-xl animate-slide-in-right md:right-4 md:w-full-mobile md:max-w-sidebar-panel pointer-events-auto"
    (click)="onSidebarClick($event)"
    (keydown.escape)="onClose()"
    aria-labelledby="sidebar-title"
    role="dialog"
    tabindex="-1"
  >
    <!-- Header with title and close button -->
    <div class="flex justify-between items-center">
      <h3 id="sidebar-title" class="text-2xl font-semibold text-blue-300 m-0">
        Inmovilizar
      </h3>
      <button
        type="button"
        class="bg-transparent border-none text-gray-400 text-xl cursor-pointer p-1 flex items-center justify-center transition-colors duration-200 hover:text-gray-500"
        (click)="onClose()"
        aria-label="Cerrar"
      >
        <i class="pi pi-times text-xl"></i>
      </button>
    </div>

    <!-- Scrollable content -->
    <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden p-0">
      <!-- Columns checkboxes -->
      <div class="p-0">
        @for (column of columns; track column.key) {
          <label
            class="flex items-center py-3 cursor-pointer transition-colors duration-200 select-none hover:bg-gray-100 hover:-mx-2 hover:px-2 hover:rounded"
            [class.opacity-50]="isColumnDisabled(column.key)"
            [class.cursor-not-allowed]="isColumnDisabled(column.key)"
          >
            <input
              type="checkbox"
              class="w-checkbox-sm h-checkbox-sm mr-3 cursor-pointer accent-blue-300 border-1.5 border-gray-400 rounded-sm disabled:cursor-not-allowed"
              [checked]="isColumnFrozen(column.key)"
              [disabled]="isColumnDisabled(column.key)"
              (change)="onColumnToggle(column.key)"
              [attr.aria-label]="'Inmovilizar columna ' + column.label"
            />
            <span class="text-base text-gray-600 font-normal">
              {{ column.label }}
            </span>
          </label>
        }
      </div>
    </div>

    <!-- Footer with clear button -->
    <div class="p-0">
      <app-button
        label="Limpiar"
        [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
        [size]="ButtonSizeEnum.MD"
        [disabled]="frozenCount() === 0"
        (handleClick)="onClearAll()"
      >
      </app-button>
    </div>
  </aside>
}
